import { get } from "lodash";

export function hydraTransform<T>(data: T[]): T[] {
    return get(data, 'hydra:member', []) as T[]
}